var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video-player',{staticClass:"player-video",attrs:{"playsinline":true,"options":_vm.playOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }